/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RefiningSubmissionVMApiResponse } from '../models/RefiningSubmissionVMApiResponse';
import type { UpdateDataSubmissionVM } from '../models/UpdateDataSubmissionVM';
import type { UpdateRefiningSubmissionVM } from '../models/UpdateRefiningSubmissionVM';
import { request as __request } from '../core/request';

export class RefiningService {

    /**
     * @returns RefiningSubmissionVMApiResponse Success
     * @throws ApiError
     */
    public static async getRefiningSubmission({
id,
}: {
id?: number,
}): Promise<RefiningSubmissionVMApiResponse> {
        const result = await __request({
            method: 'GET',
            path: `/api/refining`,
            query: {
                'id': id,
            },
        });
        return result.body;
    }

    /**
     * @returns RefiningSubmissionVMApiResponse Success
     * @throws ApiError
     */
    public static async updateRefining({
requestBody,
}: {
requestBody?: UpdateRefiningSubmissionVM,
}): Promise<RefiningSubmissionVMApiResponse> {
        const result = await __request({
            method: 'POST',
            path: `/api/refining/Update`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns RefiningSubmissionVMApiResponse Success
     * @throws ApiError
     */
    public static async updateRefiningDataSubmission({
requestBody,
}: {
requestBody?: UpdateDataSubmissionVM,
}): Promise<RefiningSubmissionVMApiResponse> {
        const result = await __request({
            method: 'POST',
            path: `/api/refining/Update-DataSubmission`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns RefiningSubmissionVMApiResponse Success
     * @throws ApiError
     */
    public static async submitRefining({
requestBody,
}: {
requestBody?: UpdateDataSubmissionVM,
}): Promise<RefiningSubmissionVMApiResponse> {
        const result = await __request({
            method: 'POST',
            path: `/api/refining/Submit`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns RefiningSubmissionVMApiResponse Success
     * @throws ApiError
     */
    public static async clearAllRefining({
requestBody,
}: {
requestBody?: UpdateDataSubmissionVM,
}): Promise<RefiningSubmissionVMApiResponse> {
        const result = await __request({
            method: 'POST',
            path: `/api/refining/Clear-All`,
            body: requestBody,
        });
        return result.body;
    }

}